import React from "react";
import {
  getPositionedBox,
  getPositionedCircle,
  getPositionedIcon,
  getPositionedText,
} from "./coord";
import { getElementTypeName } from "../../ra-lb-tools/utils/tools";

const positioned = {
  KonvaMuiIcon: getPositionedIcon,
  MyRect: getPositionedBox,
  Rect: getPositionedBox,
  Circle: getPositionedCircle,
  Text: getPositionedText,
  default: getPositionedBox,
};

export const ContainedElement = ({ elem, container }) => {
  if (!elem) return null;

  const { type, key, ref, props: originalProps } = elem;
  const { vpos, hpos, size, radius, label, width, height, offset, ...rest } =
    originalProps;

  const typeName = getElementTypeName(elem);

  let positioner = positioned[typeName];
  if (!positioner) {
    console.warn(
      `ContainedElement: Positioner not found for element '${typeName}', using default.`
    );
    positioner = positioned.default;
  }

  const positionedCoords = positioner(
    container,
    size || parseFloat(radius) || label || { width, height },
    vpos,
    hpos,
    offset
  );

  return React.createElement(type, { key, ref, ...rest, ...positionedCoords });
};
